import React from "react";
import { Stack, useTheme } from "@mui/material";

import { RankQualBox } from "./RankQualBox";

const RankQualProgBarContainer = ({
  selectedRankDetails, name1, name2, name3, inDrawer, thirdLegCount, actualLegVolumes
}) => {
  const theme = useTheme();

  // Get rank-specific metrics for required values (but use actual volumes for display)
  const leg1Metrics = actualLegVolumes?.leg1;
  const leg2Metrics = actualLegVolumes?.leg2;
  const leg3Metrics = actualLegVolumes?.leg3;

  // For Asian markets, get the base required value from available metrics
  const availableRequiredValue = leg1Metrics?.requiredValue || leg2Metrics?.requiredValue || leg3Metrics?.requiredValue || 0;

  // Create leg objects combining actual values with rank-specific required values
  const leg1 = {
    value: actualLegVolumes?.leg1 ?? 0,
    requiredValue: leg1Metrics?.requiredValue ?? availableRequiredValue,
    qualified: leg1Metrics?.qualified ?? false
  };

  const leg2 = {
    value: actualLegVolumes?.leg2 ?? 0,
    requiredValue: leg2Metrics?.requiredValue ?? availableRequiredValue,
    qualified: leg2Metrics?.qualified ?? false
  };

  const leg3 = {
    value: actualLegVolumes?.leg3 ?? 0,
    requiredValue: leg3Metrics?.requiredValue ?? availableRequiredValue,
    qualified: leg3Metrics?.qualified ?? false
  };

  // Prepare leg volumes for Asian market logic (using actual volumes)
  const allLegVolumes = {
    leg1: actualLegVolumes?.leg1 ?? 0,
    leg2: actualLegVolumes?.leg2 ?? 0,
    leg3: actualLegVolumes?.leg3 ?? 0
  };

  return (
    <Stack
      gap="8px"
      sx={{
        padding: inDrawer ?
          "0px 0px 24px 0px" : "24px 20px 24px 20px"
      }}
    >
      {
        <RankQualBox
          color1={theme.palette.unicityGreen.light}
          color2={theme.palette.unicityGreen.main}
          color3={theme.palette.unicityGreen.dark}
          legNumber="1"
          name={name1}
          leg={leg1}
          inDrawer={inDrawer}
          selectedRankDetails={selectedRankDetails}
          allLegVolumes={allLegVolumes}
        />
      }
      {
        <RankQualBox
          color1={theme.palette.unicityBlue.light}
          color2={theme.palette.unicityBlue.main}
          color3={theme.palette.unicityBlue.dark}
          legNumber="2"
          name={name2}
          leg={leg2}
          inDrawer={inDrawer}
          selectedRankDetails={selectedRankDetails}
          allLegVolumes={allLegVolumes}
        />
      }
      {
        <RankQualBox
          color1={theme.palette.unicityPurple.light}
          color2={theme.palette.unicityPurple.main}
          color3={theme.palette.unicityPurple.dark}
          legNumber="3"
          name={name3}
          leg={leg3}
          inDrawer={inDrawer}
          thirdLegCount={thirdLegCount}
          selectedRankDetails={selectedRankDetails}
          allLegVolumes={allLegVolumes}
        />
      }
    </Stack>
  )
}

export { RankQualProgBarContainer }